import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { AbstractFeatureEntityStore } from '@y42/feature';
import { StatusAlertGitFactoryService } from './status-alert-git-factory.service';
import { StatusAlertState } from './status-alert.model';

const initialState: StatusAlertState = {
  loading: true,
  last_used: {},
  starred: {},
  ui: {},
  active: null,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'alert-status-alert', idKey: '$path' })
export class StatusAlertStore extends AbstractFeatureEntityStore<StatusAlertState> {
  constructor(protected readonly gitFactory: StatusAlertGitFactoryService) {
    super({
      name: 'Status-Alert',
      gitFactory,
      initialState,
    });
  }
}
